/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
/* Services */

/**
 * Renders the Quote Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data
 * @returns {ReactElement} Quote component
 */
const Quotehni = ({ sectionContent, bg }) => {
  return (
    <Box
      width={'100%'}
      pos={'relative'}
      display={{ base: 'flex' }}
      flexDir={'column'}
      pt={{ base: '2.5rem', md: '4rem', lg: '2rem' }}
      pb={{ base: '3rem', md: '6rem', lg: '4rem' }}
      gap={{ base: '2.5rem', md: '3.5rem' }}
      _before={{
        content: "''",
        pos: 'absolute',
        width: '100%',
        right: '0',
        left: '0',
        height: '50%',
        bg: bg,
        top: '-40%',
        zIndex: '-1',
      }}
    >
      {/* first image */}
      <Box
        mx={{ base: 'auto' }}
        width={{ base: '138.04px', md: 'fit-content' }}
        height={{ base: '21.02px', md: 'auto' }}
      >
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1736931829-group-1171277233-1.png`}
        />
      </Box>
      <Box
        color={'#FFFFFF'}
        fontFamily="FedraSansStd-book-i"
        fontStyle={'italic'}
        maxW={{ base: '420px', lg: '560px' }}
        textAlign={'center'}
        mx={'auto'}
        mt={{ base: '2rem', md: '0' }}
        px={{ base: '2rem', md: '0' }}
        fontSize={{ base: '18px', lg: '20px' }}
        lineHeight={{ base: '32.4px', lg: '36px' }}
        display="flex"
        alignItems="flex-start"
      >
        <LazyLoadImageComponent
          // top={{ base: '29%', md: '39%', lg: '42%' }}
          src={`${config.imgPath}/d/46272/1736773017-vector-3.png`}
          // position={{ base: 'absolute' }}
          // left={{ base: '12%', md: '20%', lg: '22%', xl: '29%' }}
          width="auto"
          height="auto"
          mt={{ base: '-1.2rem', sm: '10px' }}
          alignSelf="flex-start"
        />
        <Text px="15px">{sectionContent[0]?.quote}</Text>
        <LazyLoadImageComponent
          // top={{ base: '60%', md: '50%', lg: '42%' }}
          src={`${config.imgPath}/d/46272/1736773017-vector-4.png`}
          // position={{ base: 'absolute' }}
          // right={{ base: '14%', md: '21%', lg: '22%', xl: '29%' }}
          width="auto"
          height="auto"
          mt={{ base: '0', sm: '10px' }}
          alignSelf={{ base: 'flex-end', sm: 'flex-start' }}
        />
      </Box>
      {/* sadguru image  */}
      <Box
        mx={{ base: 'auto' }}
        width={{ base: '141px', md: 'fit-content' }}
        height={{ base: '66px', md: 'auto' }}
        mt={{ base: '1rem', md: '0' }}
      >
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1736773017-vector-1.png`}
        />
      </Box>
    </Box>
  );
};

export default Quotehni;
